var React = require('react');

function Blob2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M134.958.94c-9.685 1.747-19.543 5.487-28.383 7.917C90.22 13.37 74.1 18.74 57.732 23.134c-15.7 4.265-31.587 9.694-44.402 20.07-31.179 25.163-.874 51.724 21.844 66.292 35.416 22.674 72.056 46.12 109.22 66.073 20.01 10.77 46.804 21.19 69.493 23.97 33.99 4.162 60.669-20.2 57.945-55.1-2.635-33.706-27.669-53.848-50.97-74.718-16.455-14.772-23.183-32.79-37.323-49.279C174.685 10.11 162.67 1.828 149.142.227a48.452 48.452 0 00-14.184.713z"}));
}

Blob2.defaultProps = {"viewBox":"0 0 273 200"};

module.exports = Blob2;

Blob2.default = Blob2;
